import React from 'react';
import {Grid, Typography} from "@mui/material";
import game_know_tribe from '../../assets/images/kozel_meet/game_know_tribe.png';
import game_propoz from '../../assets/images/kozel_meet/game_propoz.png';
import game_who_you_are from '../../assets/images/kozel_meet/game_who_you_are.png';
import crown from '../../assets/images/icons/crown.png';
import useWhatFindHereStyles from "../../styles/kozelMeetBoardGame/what_find_here";
import CalendarKozelMeet from "./whatFindHere/CalendarKozelMeet";
import SlideShow from "../SlideShow";
import imagesCarousels from "./importImages";


const WhatFindHere: React.FC = (props) => {
    const styles = useWhatFindHereStyles();
    return (
        <Grid container className={styles.container}>
            <Grid item xs={12}>
                <Typography className={styles.title}>WHAT YOU’LL FIND HERE?</Typography>
            </Grid>
            <Grid item xs={12} lg={10}>
                <Grid container className={styles.gamesContainer}>
                    <Grid item xs={8} lg={4} className={styles.gameItem}>
                        <img src={game_propoz} alt={" Img Completeaza propozitia"} className={styles.img100w}/>
                        <Typography className={styles.gameText}>A fun and simple game where you have to create funny sentences together
                        </Typography>
                    </Grid>
                    <Grid item xs={8} lg={4} className={styles.gameItem}>
                        <img src={game_know_tribe} alt={" Img cunoaste-ti tribul"} className={styles.img100w}/>
                        <Typography className={styles.gameText}>A game of funny questions that help you get to know each other better </Typography>
                    </Grid>
                    <Grid item xs={8} lg={4} className={styles.gameItem}>
                        <img src={game_who_you_are} alt={"Img Giceste cine esti"} className={styles.img100w}/>
                        <Typography className={styles.gameText}>A game with stickers on the forehead, in which you have to guess various characters </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography className={styles.title}>GOATIFUL THURSDAY!</Typography>
            </Grid>
            <Grid item xs={10} lg={8}>
                <CalendarKozelMeet/>
            </Grid>
            <Grid item xs={12} lg={8} mt={3} style={{display: "none"}}>
                <Typography className={styles.gameText}>Vezi <a target={'_blank'} rel="noreferrer" href={`/pdf/nota-de-informare_prelucrarea-datelor-cu-caracter-personal_site-kozel_obs-mv_v2_30-march-2022.pdf`}> Regulamentul campaniei</a> aici.</Typography>
            </Grid>
            <Grid item xs={12} lg={8}>
                <Typography className={styles.title}>let the fun begin! we wait you ON thursdays in kozel locations, with COOL&nbsp;<img src={crown} alt={'crown'} className={styles.crownIcon}/>&nbsp;Czech beeer, great games and și cool people!</Typography>
            </Grid>
            <Grid item xs={12} className={styles.containerSlideShow}>
                <SlideShow
                    duration={10}
                    isForwardDir={true}
                    images={imagesCarousels.filter((_, index) => index % 2 === 0)}
                    slidesToShow={5}
                />
            </Grid>
            <Grid item xs={12} className={styles.containerSlideShow}>
                <SlideShow
                    duration={10}
                    isForwardDir={false}
                    images={imagesCarousels.filter((_, index) => index % 2 !== 0)}
                    slidesToShow={5}
                />
            </Grid>
        </Grid>
    );
}

export default WhatFindHere;
